import React from 'react';
import { Link } from 'react-router-dom';

const DisclaimerLink = () => (
  <span style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 1 }}>
    <Link to="/disclaimer" style={{ fontSize: '14px', color: '#007bff', whiteSpace: 'nowrap' }}>
      Disclaimer
    </Link>
  </span>
);

export default DisclaimerLink;
